import { type QueryHookOptions, useQuery } from "@apollo/client";
import { ContentsListQuery } from "../graphql/queries";
import type {
  ContentsListQueryType,
  ContentsListQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useContentsQuery = (
  options?: QueryHookOptions<
    ContentsListQueryType,
    ContentsListQueryVariablesType
  >
) => {
  return useQuery<ContentsListQueryType, ContentsListQueryVariablesType>(
    ContentsListQuery,
    options
  );
};
